var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseStringInput',{attrs:{"required":_vm.required,"regex":_vm.emailRegEx,"value":_vm.value},on:{"input":_vm.handleInput,"validation":_vm.handleValidation}})}
var staticRenderFns = []

export { render, staticRenderFns }